import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eLegOptions {
  ADDRESS,
  PARK_AND_RIDE,
  TRAIN_STATIONS
}

export const LEG_OPTIONS: SelectOption<eLegOptions>[] = [
  {
    label: 'חניוני חנה וסע',
    value: eLegOptions.PARK_AND_RIDE,
  },
  {
    label: 'כתובת',
    value: eLegOptions.ADDRESS,
  },
  {
    label: 'תחנות רכבת',
    value: eLegOptions.TRAIN_STATIONS,
  },
];
